import React from 'react';
import ErrorMessage from './ErrorMessage';
import LongText from './LongText';
import { cachedLookup } from '../Helpers/lookupCache';

export default class ShowNameComponent extends React.Component {
  static defaultProps = {
    id: 0,
    serviceFunction: null,
    maxLength: 40,
  };

  constructor(props) {
    super(props);
    this.state = { name: props.id };
  }

  populateData() {
    if (!this.props.id) return;
    // Cached by service function + id: rows sharing an id resolve from one request instead of one per row
    cachedLookup(this.props.serviceFunction, this.props.id, this.props.serviceFunction)
      .then((result) => {
        this.setState({ name: result });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('SNC28', error));
  }

  componentDidMount() {
    this.populateData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.populateData();
    }
  }

  render() {
    if (this.state.name == null) return '-';
    if (typeof this.state.name === 'object') {
      ErrorMessage.LogDevInfo(this.state.name, 'ShowNameComponent row 50');
      return 'obj';
    }
    if (this.props.maxLength) {
      return (
        <LongText
          text={this.state.name}
          maxLength={this.props.maxLength}
        />
      );
    }
    return this.state.name;
  }
}
